import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLightBulbOn = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9 4.04651C6.49969 4.04651 4.73438 5.96023 4.73438 8.31558C4.73438 9.38721 5.14913 10.11 5.66953 10.7993C5.78241 10.9493 5.89725 11.0937 6.01538 11.2423L6.07837 11.3205C6.21619 11.4949 6.35859 11.6749 6.49181 11.8605C6.75694 12.2309 7.00566 12.6474 7.14478 13.14C7.17886 13.2717 7.16312 13.4124 7.10094 13.5319C7.03876 13.6515 6.93506 13.7405 6.812 13.7798C6.68895 13.8192 6.55629 13.8058 6.44239 13.7426C6.32848 13.6793 6.24235 13.5712 6.20241 13.4414C6.11184 13.1205 5.94188 12.8205 5.70825 12.4947C5.58496 12.3252 5.4576 12.1591 5.32631 11.9965L5.26594 11.9198C5.14781 11.7719 5.02313 11.6156 4.90172 11.4544C4.32094 10.6856 3.75 9.73326 3.75 8.31488C3.75 5.34628 5.99109 3 9 3C12.0089 3 14.25 5.34558 14.25 8.31558C14.25 9.73326 13.6791 10.6856 13.0983 11.4551C12.9769 11.6156 12.8522 11.7719 12.7341 11.9205L12.6737 11.9965C12.5359 12.1695 12.4079 12.3321 12.2918 12.4947C12.0581 12.8205 11.8882 13.1212 11.7976 13.4414C11.7557 13.5688 11.6692 13.6741 11.5561 13.7354C11.443 13.7966 11.312 13.8091 11.1905 13.7703C11.0689 13.7314 10.9661 13.6442 10.9036 13.5268C10.841 13.4094 10.8234 13.2708 10.8546 13.14C10.9943 12.6474 11.2431 12.2309 11.5088 11.8605C11.6414 11.6749 11.7838 11.4949 11.9223 11.3205L11.9846 11.2423C12.1027 11.0937 12.2176 10.9493 12.3305 10.8C12.8509 10.1093 13.2656 9.38721 13.2656 8.31558C13.2656 5.96023 11.5003 4.04651 9 4.04651ZM6.86719 14.8605H11.1328C11.2633 14.8605 11.3885 14.9156 11.4808 15.0137C11.5731 15.1119 11.625 15.2449 11.625 15.3837C11.625 15.5225 11.5731 15.6556 11.4808 15.7537C11.3885 15.8518 11.2633 15.907 11.1328 15.907H6.86719C6.73665 15.907 6.61146 15.8518 6.51916 15.7537C6.42686 15.6556 6.375 15.5225 6.375 15.3837C6.375 15.2449 6.42686 15.1119 6.51916 15.0137C6.61146 14.9156 6.73665 14.8605 6.86719 14.8605ZM7.35938 17.4767C7.35938 17.338 7.41123 17.2049 7.50353 17.1067C7.59584 17.0086 7.72103 16.9535 7.85156 16.9535H10.1484C10.279 16.9535 10.4042 17.0086 10.4965 17.1067C10.5888 17.2049 10.6406 17.338 10.6406 17.4767C10.6406 17.6155 10.5888 17.7486 10.4965 17.8467C10.4042 17.9449 10.279 18 10.1484 18H7.85156C7.72103 18 7.59584 17.9449 7.50353 17.8467C7.41123 17.7486 7.35938 17.6155 7.35938 17.4767Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.625 1.125V0.375",
			stroke: "currentColor",
			strokeWidth: .75,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2499 3.53033L14.7803 3",
			stroke: "currentColor",
			strokeWidth: .75,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.64312 3.53033L3.11279 3",
			stroke: "currentColor",
			strokeWidth: .75,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.6431 8.51367L16.3931 8.51367",
			stroke: "currentColor",
			strokeWidth: .75,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25 8.51367L1.5 8.51367",
			stroke: "currentColor",
			strokeWidth: .75,
			strokeLinecap: "round"
		})
	]
});
export default SvgLightBulbOn;
